import { render, staticRenderFns } from "./footh.vue?vue&type=template&id=05ae7f35&scoped=true"
import script from "./footh.vue?vue&type=script&lang=js"
export * from "./footh.vue?vue&type=script&lang=js"
import style0 from "./footh.vue?vue&type=style&index=0&id=05ae7f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ae7f35",
  null
  
)

export default component.exports